const getReiHubPrice = (pricings = [], unitCount) => {
  const defaultCountForPrice = 21;

  if (unitCount > defaultCountForPrice) return pricings['default'];

  return pricings[unitCount] || pricings[1];
};

export default getReiHubPrice;
